export default __webpack_public_path__ + "static/testimonials-cards-g2-logo-8f682fe6fd3be27934d87a93af1ae01a.svg";